import { isNil } from "lodash"
import Certification from "./Certification"

class CertificationRoot {
  constructor(data) {
    this.certs = isNil(data.certs)
      ? []
      : data.certs.map(cert => new Certification(cert))
  }

  calculateAllTotalCertPrice = () => {
    this.certs.forEach(cert => {
      cert.calculateTotalCertPrice()
    })
  }

  calculateAllTotalCertPriceAccumulated = () => {
    let runningTotal = 0
    this.certs.forEach(cert => {
      runningTotal = parseFloat(
        (runningTotal + cert.totalPriceDelta).toFixed(2),
      )
      cert.totalCertPrice = runningTotal
    })
  }

  calculateAllTotalPriceDelta = () => {
    this.certs.forEach(cert => {
      cert.calculateTotalPriceDelta()
    })
  }

  deleteCertById = certId => {
    const newCerts = this.certs.filter(cert => cert.id !== certId)
    this.certs = newCerts
    return this
  }
}

export default CertificationRoot
